import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService } from '../../../core';
import { UnidadeNegocio } from '../unidade-negocio';
import { UnidadeNegocioFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class UnidadeNegocioCrudHttpService implements Crud<UnidadeNegocio> {
    resource = 'unidadenegocio';

    constructor(private crudService: CrudService) { }

    /** Pesquisa todas as unidades de negócios cadastradas */
    search(): Observable<UnidadeNegocio[]> {
        return this.crudService.search<UnidadeNegocio>(this.resource);
    }

    searchWithFilter(filter: UnidadeNegocioFilter): Observable<UnidadeNegocio[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }
        return this.crudService.search<UnidadeNegocio>(this.resource, {params});
    }

    /** Procura uma única unidade de negócio através do seu ID */
    find(id: number): Observable<UnidadeNegocio> {
        return this.crudService.find<UnidadeNegocio>(this.resource, id);
    }

    /** Carrega uma única unidade de negócio através do seu ID */
    load(id: number): Observable<UnidadeNegocio> {
        return this.crudService.load<UnidadeNegocio>(this.resource, id);
    }

    /** Insere uma nova unidade de negócio */
    insert(entity: UnidadeNegocio): Observable<UnidadeNegocio> {
        return this.crudService.insert<UnidadeNegocio>(this.resource, entity);
    }

    /** Altera uma unidade de negócio existente */
    update(entity: UnidadeNegocio): Observable<UnidadeNegocio> {
        return this.crudService.update<UnidadeNegocio>(this.resource, entity);
    }

    /** Exclui uma unidade de negócio através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
